// Supabase 클라이언트 초기화
import { createClient } from '@supabase/supabase-js'

// 환경변수에서 Supabase 접속 정보 로드
// 우선: Vite 환경변수 (.env 또는 Vercel project env)
// 폴백: 하드코딩된 public anon key
// (anon key는 정의상 클라이언트 노출용 — RLS가 실제 권한 통제)
const FALLBACK_URL = 'https://biweqdzoffsqkowyhggp.supabase.co'
const FALLBACK_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJpd2VxZHpvZmZzcWtvd3loZ2dwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4ODk2MzcsImV4cCI6MjA4OTQ2NTYzN30.OMw-i10qd3iErHva_7b_Qvu30lfqc9gZKAUbJw_Qgeo'

const supabaseUrl = ((import.meta.env['VITE_SUPABASE_URL'] as string) || '').trim() || FALLBACK_URL
const supabaseAnonKey = ((import.meta.env['VITE_SUPABASE_ANON_KEY'] as string) || '').trim() || FALLBACK_ANON

if (!import.meta.env['VITE_SUPABASE_URL']) {
  console.info('[supabase] VITE_SUPABASE_URL 미설정 — fallback 사용')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// 타입 익스포트
export type { Session, User } from '@supabase/supabase-js'
